import { postPurchaseFlowStepArraySchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod/v4";

export const updatePostPurchaseFlow = {
  name: "updatePostPurchaseFlow" as const,
  input: postPurchaseFlowStepArraySchema,
  output: z.null(),
};
